import { Outlet } from "@tanstack/react-router";

/** Layout สำหรับหน้า Public Booking (เต็มจอ ไม่มี header/sidebar) */
export function PublicLayout() {
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <Outlet />
    </div>
  );
}
